import React, { useEffect, useState } from "react";
import { Hero } from "../components/hero";
import { Services } from "../components/services";
import { About } from "../components/about";
import { Features } from "../components/features";
import { Testimonials } from "../components/testimonials";
// ...import others
import JsonData from "../data/data.json";

const Home = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <>
      <Hero data={landingPageData.Hero} />
      <Services data={landingPageData.Services} />
      <About data={landingPageData.About} />
      <Features title={JsonData.whyChooseUs.title} subTitle={JsonData.whyChooseUs.subTitle} data={JsonData.whyChooseUs.Features.map(f => ({
        icon: f.icon,
        title: f.title,
        subTitle: f.subTitle,
        text: f.description
      }))} />
      <Testimonials data={landingPageData.Testimonials} />
    </>
  );
};

export default Home;
